import { render, staticRenderFns } from "./AsalInfo.vue?vue&type=template&id=51308db7"
import script from "./AsalInfo.vue?vue&type=script&lang=js"
export * from "./AsalInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports